import {DropdownMenuItem} from '@/base/ui/dropdownMenu'
import {cn} from '@/lib/utils'

export interface IWuMenuItemProps
  extends Omit<React.HtmlHTMLAttributes<HTMLDivElement>, 'onSelect'> {
  Icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  disabled?: boolean
  onSelect?: (e: Event) => void
  preventCloseOnSelect?: boolean
}
export const WuMenuItem: React.FC<IWuMenuItemProps> = props => {
  const {
    children,
    className,
    Icon,
    iconPosition = 'left',
    disabled,
    onSelect,
    preventCloseOnSelect,
  } = props
  const customClass = cn(
    'flex items-center gap-2',
    Icon && (iconPosition === 'left' ? '' : 'justify-between flex-row-reverse'),
    className,
  )

  const handleOnSelect = (e: Event): void => {
    if (onSelect) onSelect(e)
    if (preventCloseOnSelect) e.preventDefault()
  }
  return (
    <DropdownMenuItem
      onSelect={handleOnSelect}
      disabled={disabled}
      className={customClass}
    >
      {Icon && <div className="text-base">{Icon}</div>}
      {children}
    </DropdownMenuItem>
  )
}
